export default __webpack_public_path__ + "static/media/suv2.c432cb96.webp";